import {
  GetPortfolioChart,
  GetPortfolioInvestmentForm,
  GetPortfolioInvestmentList,
  GetPortfolioTradeAvgForCoin,
  GetPortfolioTradeAvgForCoinList,
  GetPortfolioTradeAvgForCoinListStartDate,
  GetPortfolioTradeAvgForm,
  GetPortfolioTradeAvgList,
} from "./api";

import http from "config/http";

const portfolioApi = {
  getPortfolioInvestmentForm: async () =>
    await http.get(GetPortfolioInvestmentForm),

  getPortfolioTradeAvgForm: async () =>
    await http.get(GetPortfolioTradeAvgForm),

  getPortfolioChart: async ({ walletTypeId }) =>
    await http.get(GetPortfolioChart({ walletTypeId })),

  getPortfolioTradeAvgList: async ({ walletTypeId, dateTypeId, startDate }) =>
    await http.get(
      GetPortfolioTradeAvgList({
        walletTypeId,
        dateTypeId,
        startDate,
      })
    ),

  getPortfolioInvestmentList: async ({ dateTypeId, startDate }) =>
    await http.get(
      GetPortfolioInvestmentList({
        dateTypeId,
        startDate,
      })
    ),

  getPortfolioTradeAvgForCoinList: async ({
    coinId,
    dateTypeId,
    walletTypeId,
    pageNumber,
    pageSize,
    startDate,
  }) =>
    await http.get(
      GetPortfolioTradeAvgForCoinList({
        coinId,
        dateTypeId,
        walletTypeId,
        pageNumber,
        pageSize,
        startDate,
      })
    ),

  getPortfolioTradeAvgForCoinListStartDate: async ({
    coinId,
    dateTypeId,
    walletTypeId,
    pageNumber,
    pageSize,
    startDate,
  }) =>
    await http.get(
      GetPortfolioTradeAvgForCoinListStartDate({
        coinId,
        dateTypeId,
        walletTypeId,
        pageNumber,
        pageSize,
        startDate,
      })
    ),

  getPortfolioTradeAvgForCoin: async ({ coinId, dateTypeId, walletTypeId }) =>
    await http.get(
      GetPortfolioTradeAvgForCoin({
        coinId,
        dateTypeId,
        walletTypeId,
      })
    ),
};

export default portfolioApi;
